module.exports = __webpack_public_path__ + "static/media/liquid_22_detail_04.abeb16e0.jpg";